
import React from 'react'

import './InputDate.scss'

interface Props {
  value: string
  onChange?: (value: string) => void
  onClick?: () => void
  placeholder?: string
  className?: string
  disabled?: boolean
  readonly?: boolean
  invalid?: boolean
  asButton?: boolean
}

const InputDate = (props: Props) => {

  const {
    value,
    onChange,
    onClick,
    className = '',
    invalid,
    asButton,
    ...rest
  } = props

  const getClassName = () => {

    if (asButton) {
      return 'input-date iconless'
    }

    if (className) {

      return `input-date ${className} ${invalid ? 'invalid' : ''}`
    }

    return 'input-date'
  }

  return (
    <input
      type='date'
      className={getClassName()}
      value={value}
      onChange={(e: any) => {

        if (onChange) onChange(e.target.value)
      }}
    onClick={onClick}
      {...rest}
    />
  )
}

export default InputDate
